import { RootState } from 'editor/src/store/index';

import isVariantsSidebarVisible from './isVariantsSidebarVisible';

const isRightBarVisible = (state: RootState) =>
  !state.variants.configuration.singleSelection && isVariantsSidebarVisible(state);

export default isRightBarVisible;
